module.exports = __webpack_public_path__ + "static/media/building.98464c26.svg";